/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Foot_SemanticInputs */

const en_search_foot_semantic = /** @type {(inputs: Search_Foot_SemanticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`getanyapi.com · semantic search`)
};

const zh_hans1_search_foot_semantic = /** @type {(inputs: Search_Foot_SemanticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`getanyapi.com · 语义搜索`)
};

const pt_br2_search_foot_semantic = /** @type {(inputs: Search_Foot_SemanticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`getanyapi.com · pesquisa semântica`)
};

const es_search_foot_semantic = /** @type {(inputs: Search_Foot_SemanticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`getanyapi.com · búsqueda semántica`)
};

const fr_search_foot_semantic = /** @type {(inputs: Search_Foot_SemanticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`getanyapi.com · recherche sémantique`)
};

const de_search_foot_semantic = /** @type {(inputs: Search_Foot_SemanticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`getanyapi.com · semantische Suche`)
};

const ru_search_foot_semantic = /** @type {(inputs: Search_Foot_SemanticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`getanyapi.com · семантический поиск`)
};

const it_search_foot_semantic = /** @type {(inputs: Search_Foot_SemanticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`getanyapi.com · ricerca semantica`)
};

/**
* | output |
* | --- |
* | "getanyapi.com · semantic search" |
*
* @param {Search_Foot_SemanticInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const search_foot_semantic = /** @type {((inputs?: Search_Foot_SemanticInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Foot_SemanticInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_search_foot_semantic(inputs)
	if (locale === "pt-BR") return pt_br2_search_foot_semantic(inputs)
	if (locale === "es") return es_search_foot_semantic(inputs)
	if (locale === "fr") return fr_search_foot_semantic(inputs)
	if (locale === "de") return de_search_foot_semantic(inputs)
	if (locale === "ru") return ru_search_foot_semantic(inputs)
	if (locale === "it") return it_search_foot_semantic(inputs)
	return en_search_foot_semantic(inputs)
});